import * as React from 'react'
import { MouseEventHandler, ReactElement, useMemo } from 'react'
import { AnyDate, DateFormats, formatDate, parseDate } from '../../helpers/dateHelper'
import { Text, Tooltip } from '@fluentui/react-components'
import { useTranslation } from 'react-i18next'

export type FormattedDateRangeProps = {
    fromDate: AnyDate
    toDate: AnyDate
    date: AnyDate
    format?: DateFormats
    className?: string
    onClick?: MouseEventHandler
}

export default function FormattedDateRange(props: FormattedDateRangeProps): ReactElement {
    const { i18n } = useTranslation()

    const dateString = useMemo(() => formatDate(props.date, { locale: i18n.language }), [i18n.language])
    const tooltipString = useMemo(
        () =>
            [
                parseDate(props.fromDate, { locale: i18n.language })?.toFormat(props.format || DateFormats.Full),
                parseDate(props.toDate, { locale: i18n.language })?.toFormat(props.format || DateFormats.Full),
            ]
                .filter(Boolean)
                .join(' - '),
        [i18n.language],
    )

    return (
        <Tooltip relationship={'label'} content={tooltipString} withArrow>
            <Text size={200} className={props.className} {...props}>
                {dateString}
            </Text>
        </Tooltip>
    )
}
